import React from 'react';

import { useApp } from '../../../store/AppContext';
import { eligiblePhasesForGeneral } from '../../../utils/phases';

export default function PhaseSelect({ e, i }) {
  const { appState, updateUnmatched } = useApp();
  const remapClient = (appState.clients || []).find((c) => c.id === e.remapClientId);
  const remapPhases = remapClient ? eligiblePhasesForGeneral(remapClient, false) : [];
  if (remapPhases.length > 1) {
    return (
      <select
        className="text-[11px] py-[3px] px-[5px] [border:1px_solid_#ddd] rounded-[4px] bg-white"
        value={e.remapPhaseId || ''}
        onChange={(ev) => updateUnmatched(i, 'remapPhaseId', ev.target.value)}
      >
        <option value="">— Phase —</option>
        {remapPhases.map((ph) => (
          <option key={ph.id} value={ph.id}>
            {ph.nom}
          </option>
        ))}
      </select>
    );
  }
  return (
    <div className="text-[11px] py-[3px] px-[5px] text-grey-pale">{remapPhases[0]?.nom || '—'}</div>
  );
}
